import useShop from "@saleor/hooks/useShop";
import useUser from "@saleor/hooks/useUser";
export const hasFullAccess = () => {
  const user = useUser();
  const shop = useShop();

  const userPermissions = user?.user.userPermissions.map(p => p.code) || [];

  const permissions = (shop?.permissions || []).map(perm => ({
    ...perm,
    disabled: !userPermissions.includes(perm.code)
  }));

  const hasFullAccess = permissions.filter(
    disabled => disabled.disabled === true
  );

  const isSuperAdmin = hasFullAccess.length === 0 ? true : false;

  return isSuperAdmin;
};
